import { useEffect } from 'react';
import { toast } from 'sonner';
import { usePWAUpdate } from '../../hooks/usePWAUpdate';

export function PWAUpdatePrompt() {
  const { update, registration } = usePWAUpdate();

  useEffect(() => {
    if (registration?.waiting) {
      toast.info('New version available!', {
        action: {
          label: 'Update',
          onClick: update,
        },
        duration: Number.POSITIVE_INFINITY,
      });
    }
  }, [registration?.waiting, update]);

  return null;
} 